var DOWNLOAD_SELECTORS = [
    '.win64_url',
    '.win32_url',
    '.macM1_url',
    '.macIntel_url',
    '.ios_url',
    '.android_url',
    '.android_mobile',
];
var PLATFORM_MAP = {
    win32_url: 1,
    win64_url: 2,
    macM1_url: 3,
    macIntel_url: 4,
    android_url: 5,
    android_mobile: 6,
    ios_url: 7,
};
function resolvePlatform(el) {
    for (var _i = 0, _a = Object.entries(PLATFORM_MAP); _i < _a.length; _i++) {
        var _b = _a[_i], cls = _b[0], code = _b[1];
        if (el.classList.contains(cls.replace('.', ''))) {
            return code;
        }
    }
    return 0;
}
function bindDownloadLinks(root, selector, urlField) {
    var nodes = Array.from(root.querySelectorAll(selector));
    if (!nodes.length || typeof md5 === 'undefined') {
        return;
    }
    nodes.forEach(function (node) {
        var el = node;
        if (el.dataset.procenterDownloadBound === '1') {
            return;
        }
        el.dataset.procenterDownloadBound = '1';
        el.addEventListener('click', function (e) {
            e.stopPropagation();
            var promotionMatch = window.location.href.match(/promotionid=([^&]+)/);
            var promotionId = promotionMatch ? promotionMatch[1] : null;
            var loadPromotion = new URL(window.location.href).searchParams.get('loadPromotion') || '';
            var hasPromotion = Boolean(promotionId);
            var hasLoadPromotion = Boolean(loadPromotion);
            var gId = el.getAttribute('data-gid');
            var params = { g_id: gId, promotionid: promotionId, loadPromotion: loadPromotion };
            $.get('/UnifiedInterface/getProductInfo', params, function (res) {
                if (res.code !== 200) {
                    console.error('link get fail, get url not success');
                    return;
                }
                var downloadUrl = res.data[urlField];
                var ts = Date.now();
                var sign = md5(JSON.stringify({ ts: ts }) + 'XS6kvcsbpvLpjDIap2hS3YaWibHk7ibE');
                $.get('/index/UnifiedInterface/downloadButtonRecord', {
                    g_id: Number(gId),
                    mark: el.getAttribute('data-markid'),
                    platform: resolvePlatform(el),
                    url: document.location.href,
                });
                var joiner = downloadUrl.includes('?') ? '&' : '?';
                window.location.href = hasPromotion || hasLoadPromotion
                    ? "".concat(downloadUrl, "&ts=").concat(ts, "&sign=").concat(sign)
                    : "".concat(downloadUrl).concat(joiner, "ts=").concat(ts, "&sign=").concat(sign);
            });
        });
    });
}
/** 产品卡片下载按钮（与产品中心一致） */
export function initProcenterDownloadButtons(root) {
    if (root === void 0) { root = document; }
    if (typeof $ === 'undefined') {
        return;
    }
    DOWNLOAD_SELECTORS.forEach(function (selector) {
        var field = selector.replace('.', '');
        bindDownloadLinks(root, selector, field);
    });
}
